const TIME_FORMAT = "h:mm a";

export { TIME_FORMAT };
